import numeral from 'numeral';

export function getNumber (value){
    let value2 = numeral(value);

    return value2.format('0,0');
}